import { gql } from "@apollo/client";

// kan-111 AI Reference Taker — candidate References tab section.
// Enum fields (aiStatus, referenceStatus, needsHumanReason, declineReason)
// come back as GraphQL enum KEYS (e.g. "SEND_OUTREACH", "PENDING").

const AI_REFERENCE_ENTRY_VIEW_FIELDS = `
  referenceId
  candidateId
  referenceName
  title
  company
  email
  phoneNumber
  relationshipToCandidate
  referenceStatus
  entryId
  aiStatus
  needsHumanReason
  declineReason
  declineNote
  lastOutreachAt
  completedAt
  closedAt
  lastActivityAt
  requestedBy {
    id
    firstName
    lastName
  }
`;

export const GET_AI_REFERENCE_ENTRIES_FOR_CANDIDATE = gql`
  query AiReferenceEntriesForCandidate($candidateId: String!) {
    aiReferenceEntriesForCandidate(candidateId: $candidateId) {
      ${AI_REFERENCE_ENTRY_VIEW_FIELDS}
    }
  }
`;

export const GET_AI_REFERENCE_ANSWERS = gql`
  query AiReferenceAnswers($referenceEntryId: String!) {
    aiReferenceAnswers(referenceEntryId: $referenceEntryId) {
      referenceEntryId
      status
      transcript
      recordingUrl
      completedAt
      answers {
        label
        prompt
        answer
        sortOrder
        fieldKey
      }
    }
  }
`;

export const CREATE_REFERENCE_CONTACT = gql`
  mutation CreateReferenceContact($input: CreateReferenceContactInput!) {
    createReferenceContact(input: $input) {
      id
      referenceName
      title
      company
      email
      phoneNumber
      relationshipToCandidate
      status
    }
  }
`;

export const UPDATE_REFERENCE_CONTACT = gql`
  mutation UpdateReferenceContact(
    $referenceId: String!
    $input: UpdateReferenceContactInput!
  ) {
    updateReferenceContact(referenceId: $referenceId, input: $input) {
      id
      referenceName
      title
      company
      email
      phoneNumber
      relationshipToCandidate
      status
    }
  }
`;

export const DELETE_REFERENCE_CONTACT = gql`
  mutation DeleteReferenceContact($referenceId: String!) {
    deleteReferenceContact(referenceId: $referenceId)
  }
`;

export const ENQUEUE_AI_REFERENCE = gql`
  mutation EnqueueAiReference($referenceId: String!) {
    enqueueAiReference(referenceId: $referenceId) {
      ${AI_REFERENCE_ENTRY_VIEW_FIELDS}
    }
  }
`;

// kan-111 round 2 — per-candidate reference question set (D1/D3). `source`
// comes back as the enum KEY: "DEFAULT" (global template, wording locked) or
// "MANUAL" (recruiter-written, editable). A DEFAULT row the recruiter removed
// stays in the list with isRemoved = true (D2: hidden on the PDF).
const AI_REFERENCE_CANDIDATE_QUESTION_SET_FIELDS = `
  candidateId
  isCustom
  questions {
    id
    templateId
    source
    label
    prompt
    fieldKey
    sortOrder
    isRemoved
  }
`;

export const GET_AI_REFERENCE_CANDIDATE_QUESTIONS = gql`
  query AiReferenceCandidateQuestions($candidateId: String!) {
    aiReferenceCandidateQuestions(candidateId: $candidateId) {
      ${AI_REFERENCE_CANDIDATE_QUESTION_SET_FIELDS}
    }
  }
`;

export const SAVE_AI_REFERENCE_CANDIDATE_QUESTIONS = gql`
  mutation SaveAiReferenceCandidateQuestions(
    $input: SaveAiReferenceCandidateQuestionsInput!
  ) {
    saveAiReferenceCandidateQuestions(input: $input) {
      ${AI_REFERENCE_CANDIDATE_QUESTION_SET_FIELDS}
    }
  }
`;

export const RESTORE_AI_REFERENCE_DEFAULT_QUESTIONS = gql`
  mutation RestoreAiReferenceDefaultQuestions($candidateId: String!) {
    restoreAiReferenceDefaultQuestions(candidateId: $candidateId) {
      ${AI_REFERENCE_CANDIDATE_QUESTION_SET_FIELDS}
    }
  }
`;

/** Round 3: the PDF's exact ordered Q/A rows for an AI-handled reference ([] for manual ones). */
export const GET_AI_REFERENCE_REPORT_ROWS = gql`
  query AiReferenceReportRows($referenceId: String!) {
    aiReferenceReportRows(referenceId: $referenceId) {
      label
      answer
    }
  }
`;
